import { gateway } from "../../../gateway";
import { SelfWorkforceResponse, WorkforceMember } from "../interfaces/workforces.interface";

export const getWorkforce = async (): Promise<WorkforceMember[]> => {
    const response = await gateway.get<SelfWorkforceResponse>(`/workforce/self`);
    return response.data.data;
}
